// removed by extract-text-webpack-plugin
module.exports = {"section":"index__section___2Y8gh","title":"index__title___1xX2L","body":"index__body___2LU57","collapseIcon":"index__collapseIcon___1aPTq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Section/index.less
// module id = 490
// module chunks = 3